/** Sample values for admin Email Preview only — not used when sending real emails. */
const TOKEN_SAMPLES: Record<string, string> = {
  '{{first_name}}': 'Alex',
  '{{last_name}}': 'Rivera',
  '{{admins}}': 'Alex',
  '{{competition_name}}': 'City and County of San Francisco Sustainability Challenge 2026',
  '{{competition_start_date}}': 'October 1, 2026',
  '{{competition_end_date}}': 'October 30, 2026 at 6:00 PM Pacific',
  '{{department_name}}': 'Environment',
  '{{participating_departments}}':
    'Airport Commission, Environment, Planning, Public Works, Rec and Park',
  '{{login_url}}': 'https://www.coolcampuschallenge.org/ccsf',
  '{{contact_email}}': 'Jax.Puliatti@sfgov.org, Sierra.Barsten@sfgov.org, or Brian.Reyes@sfgov.org',
  '{{frontend_host}}': 'www.coolcampuschallenge.org',
  '{{recipient_name}}': 'Alex Rivera',
  '{{actor_name}}': 'Jamie Chen',
  '{{title}}': 'Sample notification title',
  '{{body}}': 'Sample notification body text.',
  '{{action_url}}': 'https://www.coolcampuschallenge.org/ccsf/story/42',
  '{{action_label}}': 'Click Here',
  '{{division_name}}': 'Zero Waste'
};

export function applyTemplatePreviewTokens(html: string): string {
  let out = html || '';
  Object.keys(TOKEN_SAMPLES).forEach((token) => {
    out = out.split(token).join(TOKEN_SAMPLES[token]);
  });
  return out;
}

/** Strip tags for multipart plain-text body kept in sync with HTML. */
export function htmlToPlainText(html: string): string {
  return (html || '')
    .replace(/<\s*br\s*\/?>/gi, '\n')
    .replace(/<\/\s*p\s*>/gi, '\n\n')
    .replace(/<\/\s*div\s*>/gi, '\n')
    .replace(/<\/\s*h[1-6]\s*>/gi, '\n\n')
    .replace(/<\/\s*li\s*>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#39;/g, '\'')
    .replace(/&quot;/g, '"')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

export const INSERTABLE_TEMPLATE_TOKENS = [
  { label: 'First name (personalized per recipient)', token: '{{first_name}}' },
  { label: 'Last name', token: '{{last_name}}' },
  { label: 'Full recipient name', token: '{{recipient_name}}' },
  { label: 'Admin greeting (same as first name)', token: '{{admins}}' },
  { label: 'Competition name', token: '{{competition_name}}' },
  { label: 'Competition start date', token: '{{competition_start_date}}' },
  { label: 'Competition end date', token: '{{competition_end_date}}' },
  { label: 'Department name', token: '{{department_name}}' },
  { label: 'Participating departments', token: '{{participating_departments}}' },
  { label: 'Login URL', token: '{{login_url}}' },
  { label: 'Action / review URL', token: '{{action_url}}' },
  { label: 'Action button label', token: '{{action_label}}' },
  { label: 'Actor name', token: '{{actor_name}}' },
  { label: 'Notification title', token: '{{title}}' },
  { label: 'Notification body', token: '{{body}}' },
  { label: 'Contact email', token: '{{contact_email}}' },
  { label: 'Frontend host', token: '{{frontend_host}}' },
  { label: 'Division name', token: '{{division_name}}' }
];

export const TEMPLATE_METADATA: Record<string, { purpose: string; sendsWhen: string; recipients: string }> = {
  signup_confirmation: {
    purpose: 'Confirms preregistration on the prelaunch landing page.',
    sendsWhen: 'Immediately after someone signs up for launch notifications.',
    recipients: 'Preregistered email address'
  },
  welcome: {
    purpose: 'Welcomes preregistered participants when the Challenge opens.',
    sendsWhen: 'At launch welcome time (often 7:00 AM Pacific on opening day).',
    recipients: 'All preregistered participants'
  },
  account_welcome: {
    purpose: 'Confirms a verified account after someone creates / joins the Challenge.',
    sendsWhen: 'Immediately after each verified account signup.',
    recipients: 'Newly verified participant'
  },
  hero_nominated: {
    purpose: 'Confirms a Highlight a Hero nomination to the person who submitted it.',
    sendsWhen: 'When a participant nominates a tagged CCSF staff hero.',
    recipients: 'Nominator (submitter)'
  },
  hero_nomination_received: {
    purpose: 'Tells a nominated employee that a fellow staff member highlighted them.',
    sendsWhen: 'When someone is tagged as the hero on a Highlight a Hero story.',
    recipients: 'Nominee'
  },
	content_flagged: {
    purpose: 'Alerts Challenge admins that participant content needs moderation review.',
    sendsWhen: 'When a participant flags a story or comment for review.',
    recipients: 'Competition admins (and scoped division captains)'
  },
  content_flag_removed: {
    purpose: 'Tells admins and the content owner that a flag was withdrawn or dismissed.',
    sendsWhen: 'When the last reporter unflags, or a moderator dismisses/removes the case.',
    recipients: 'Competition admins, scoped division captains, and content owner'
  }
};
